import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AppContext } from 'src/utils';

const LightningScreeningLayout = ({ children }: any) => {
  const { currentUser } = useContext(AppContext);

  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card-title">
            <h4>SCREEN CUSTOMERS</h4>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="tabs-header p-0">
            <div className="d-flex tabs">
              <NavLink to="/lightning-screening/business">
                <h4 className="m-0">Business</h4>
              </NavLink>
              
              <NavLink to="/lightning-screening/individual">
                <h4 className="m-0">Individual</h4>
              </NavLink>

              { currentUser?.digital_wallet_visible ? (
                <NavLink to="/lightning-screening/digital-wallet">
                  <h4 className="m-0">Digital Wallet</h4>
                </NavLink>
                ) : null
              }
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LightningScreeningLayout;
